export default __webpack_public_path__ + "static/media/left-triangle.64368015.svg";